export default function ShippingRowOpp({ row, selectTracking }) {
  return (
    <tr>
      <td>
        <button
          className="btn btn-link"
          onClick={() => selectTracking(row.tracking_id, row.shipping_company)}
        >
          {row.tracking_id}{" "}
          <span className="badge badge-primary badge-outline">
            {row.shipping_company}
          </span>
        </button>
        <div>
          <div
            className={
              "badge badge-" +
              (row.shipping_type === "Vendor to VAD" ? "warning" : "success")
            }
          >
            {row.shipping_type}
          </div>
        </div>
      </td>
      <td>
        {row.status_description}
        {row.status_code === "delivered" && (
          <div>
            <div className="badge badge-success">
              {new Date(row.time_of_delivery).toLocaleDateString()}
            </div>
          </div>
        )}
      </td>
      <td>
        {new Date(row.last_update).toLocaleDateString()}
        <div>
          <small>{new Date(row.last_update).toLocaleTimeString()}</small>
        </div>
      </td>
    </tr>
  );
}
